import { render, staticRenderFns } from "./PolicyInsured.vue?vue&type=template&id=adf8bffe&"
import script from "./PolicyInsured.vue?vue&type=script&lang=js&"
export * from "./PolicyInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports